import { SeMappableModel } from '../se-service'

export class ParticipationRequirement extends SeMappableModel {
  public id: number
  public program_participant_type_id: number
  public has_edocs: boolean
}
